@if (filterForm) {
    <mat-drawer-container [hasBackdrop]="true">
        <mat-drawer #sidenav [mode]="'over'">
            <app-risk-insights-filter-sidebar
                [filterForm]="filterForm"
                (closeButtonClicked)="sidenav.close()"
                [timeFrameList]="timeFrameList"
                [userList]="userList$ | async"
                [showGroupFilters]="groupsEnabled"
                [groupFilterOptions]="groupFilterOptions$ | async">
            </app-risk-insights-filter-sidebar>
        </mat-drawer>
        <mat-drawer-content class="app-content listings">
            <app-risk-insights-filter-topbar
                [filterForm]="filterForm"
                [currentFilters]="currentFilters"
                (filterButtonClicked)="sidenav.open()"
                [userList]="userList$ | async"
                [groupFilterOptions]="groupFilterOptions$ | async">
            </app-risk-insights-filter-topbar>

            <div class="app-content px-0">
                @if (stats$ | async; as stats) {
                    @if (stats.meta.results) {
                        <app-risk-type-stats
                            [data]="stats.data"></app-risk-type-stats>
                    } @else {
                        <div
                            class="flex flex-column align-items-center justify-content-center text-center p-5 risk-empty-state">
                            <img
                                src="/assets/img/empty-insights.svg"
                                alt="No stats to display" />
                            <h2 class="mt-4 mb-2">No Statistics to Display</h2>
                            <p class="text-color-secondary m-0">
                                No risk management data exists for the selected
                                filters yet.
                            </p>
                            <a
                                class="mt-3 cursor-pointer open-filters"
                                (click)="
                                    sidenav.open(); $event.stopPropagation()
                                ">
                                Change Filtered View
                            </a>
                        </div>
                    }
                } @else {
                    <app-loading-indicator></app-loading-indicator>
                }
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
}
